export default "__VITE_ASSET__BZ7uKy7U__"